/** Creates an array of empty arrays */
export function createEmptyArrays<T>(count: number): T[][] {
    const result: T[][] = [];

    for (let i = 0; i < count; i++) {
        result.push([]);
    }

    return result;
}
